import React, { useContext, useRef, useState } from "react"
import { useNavigate } from "react-router-dom"
import ProjectContext from "context/projects/projectContext"
import CloseIcon from "@mui/icons-material/Close"
import EditOutlinedIcon from "@mui/icons-material/EditOutlined"
import { makeStyles } from "@material-ui/core/styles"
import { CircularProgress, Modal } from "@mui/material"
import PropTypes from "prop-types"
import AddContact from "../../components/OldContacts/ContactTable/addContact"
import ModalImageProject from "./ModalImageProject"
import CheckCircleOutlineSharpIcon from "@mui/icons-material/CheckCircleOutlineSharp"
import ErrorOutlineSharpIcon from "@mui/icons-material/ErrorOutlineSharp"
import i18n from "i18n"

function getModalStyle() {
  const top = 50
  const left = 50
  return {
    top: `${top}%`,
    left: `${left}%`,
    transform: `translate(-${top}%, -${left}%)`,
  }
}

const useStyles = makeStyles(theme => ({
  paper: {
    position: "absolute",
    width: "522px",
    backgroundColor: theme.palette.background.paper,
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
    borderRadius: 6,
    maxHeight: "calc(100vh - 100px)",
    overflowY: "auto",
    overflowX: "hidden",
  },
}))

const ModalFirstProject = ({
  modal_first,
  setmodal_first,
  imInDocuments,
  imTemplate,
}) => {
  const [modalStyle] = useState(getModalStyle)
  const classes = useStyles()

  /*Funciones para las etiquetas*/

  const [tagsFinal, setTagsFinal] = useState([])

  const [openAdd, setOpenAdd] = useState(false)

  //useEffect(() => {  getUser()}, [])

  /*Referencias para cambio de estilos en validacion de formulario*/
  const refNombre = useRef(null)
  const refMovil = useRef(null)
  const refEmail = useRef(null)
  const refDni = useRef(null)
  const refEmpresa = useRef(null)
  const refTags = useRef(null)
  const refDir = useRef(null)

  /*Referencias para iconos confirm and error*/
  const refNombreConfirm = useRef(null)
  const refMovilConfirm = useRef(null)
  const refEmailConfirm = useRef(null)
  const refDniConfirm = useRef(null)
  const refEmpresaConfirm = useRef(null)
  const refTagsConfirm = useRef(null)
  const refDirConfirm = useRef(null)

  const refNombreError = useRef(null)
  const refMovilError = useRef(null)
  const refEmailError = useRef(null)
  const refDniError = useRef(null)
  const refEmpresaError = useRef(null)
  const refDirError = useRef(null)

  let valida = false
  let validaNombre = true

  const [selectedContact, setSelectedContact] = useState(null)

  const handleOnClick = e => {
    if (e.target.name == "name") {
      refNombre.current["id"] = "focus"
      refNombreConfirm.current.id = "confirmNotVisible"
      refNombreError.current.id = "errorNotVisible"
    } else if (e.target.name == "client") {
      refDni.current["id"] = "focus"
      refDniConfirm.current.id = "confirmNotVisible"
      refDniError.current.id = "errorNotVisible"
    } else if (e.target.name == "description") {
      refEmpresa.current["id"] = "focus"
      refEmpresaConfirm.current.id = "confirmNotVisible"
      refEmpresaError.current.id = "errorNotVisible"
    } else if (e.target.name == "orgAddress") {
      refDir.current["id"] = "focus"
      refDirConfirm.current.id = "confirmNotVisible"
      refDirError.current.id = "errorNotVisible"
    } else if (e.target.name == "identifierNumber") {
      refMovil.current["id"] = "focus"
      refMovilConfirm.current.id = "confirmNotVisible"
      refMovilError.current.id = "errorNotVisible"
    } else if (e.target.name == "email") {
      refEmail.current["id"] = "focus"
      refEmailConfirm.current.id = "confirmNotVisible"
      refEmailError.current.id = "errorNotVisible"
    } else if (e.target.name == "tags") {
      refTags.current["id"] = "focus"
    }
  }

  const projectContext = useContext(ProjectContext)
  const { createProject, selectedProject } = projectContext
  const { projects, getProjects } = projectContext

  const [campos, guardarCampos] = useState({
    name: "",
    description: "",
    identifierNumber: "",
    orgAddress: "",
    client: "",
    tags: [],
    imagen: "",
    is_template: imTemplate ? true : false,
  })

  const obtenerCampos = e => {
    guardarCampos({
      ...campos,
      [e.target.name]: e.target.value,
    })
  }

  const navigate = useNavigate()
  const [loading, setLoading] = useState(false)

  const onSubmit = async e => {
    //e.preventDefault();
    if (campos.name.length > 0) {
      validaNombre = true
      refNombre.current.id = " "
      refNombreConfirm.current.id = "confirmVisibleNombre"
      refNombreError.current.id = "errorNotVisible"
    } else {
      refNombre.current.id = "errorValidation"
      validaNombre = false
      refNombreConfirm.current.id = "confirmNotVisible"
      refNombreError.current.id = "errorVisibleNombre"
    }

    if (validaNombre) {
      valida = true
    }
    if (valida == true) {
      campos.tags = tagsFinal
      campos.imagen = image
      if (selectedContact == null) {
        campos.client = " "
      } else {
        campos.client = selectedContact.completeName
      }
      setLoading(true)
      const res = await createProject(campos)
      setLoading(false)
      getProjects()
      if (!imInDocuments) {
        if (imTemplate) {
          navigate("/bancodeprecios/templateV2/" + res.projectId)
        } else {
          navigate("/budgeting/" + res.projectId)
        }
      } else {
        setmodal_first(false)
      }
    }
  }
  const [focused, setFocused] = React.useState(false)
  const onFocus = e => {
    setFocused(true)
    if (e.target.name == "name") {
      refNombre.current["id"] = "focus"
      refNombreConfirm.current.id = "confirmNotVisible"
      refNombreError.current.id = "errorNotVisible"
    } else if (e.target.name == "client") {
      refDni.current["id"] = "focus"
      refDniConfirm.current.id = "confirmNotVisible"
      refDniError.current.id = "errorNotVisible"
    } else if (e.target.name == "description") {
      refEmpresa.current["id"] = "focus"
      refEmpresaConfirm.current.id = "confirmNotVisible"
      refEmpresaError.current.id = "errorNotVisible"
    } else if (e.target.name == "orgAddress") {
      refDir.current["id"] = "focus"
      refDirConfirm.current.id = "confirmNotVisible"
      refDirError.current.id = "errorNotVisible"
    } else if (e.target.name == "identifierNumber") {
      refMovil.current["id"] = "focus"
      refMovilConfirm.current.id = "confirmNotVisible"
      refMovilError.current.id = "errorNotVisible"
    } else if (e.target.name == "tags") {
      refTags.current["id"] = "focus"
    }
  }
  const handleEnter = event => {
    if (event.key.toLowerCase() === "enter") {
      const form = event.target.form
      const index = [...form].indexOf(event.target)
      form.elements[index + 1].focus()
      event.preventDefault()
    }
  }
  const onBlur = e => {
    setFocused(false)
    if (e.target.name == "name") {
      if (campos.name.length > 0) {
        validaNombre = true
        refNombre.current.id = " "
        refNombreConfirm.current.id = "confirmVisibleNombre"
        refNombreError.current.id = "errorNotVisible"
      } else {
        refNombre.current.id = "errorValidation"
        validaNombre = false
        refNombreConfirm.current.id = "confirmNotVisible"
        refNombreError.current.id = "errorVisibleNombre"
      }
    } else if (e.target.name == "identifierNumber") {
      if (campos.identifierNumber.length > 0) {
        validaMovil = true
        refMovil.current.id = " "
        refMovilError.current.id = "errorNotVisible"
        refMovilConfirm.current.id = "confirmVisibleId"
      } else {
        refMovil.current.id = "errorValidation"
        validaMovil = false
        refMovilError.current.id = "errorVisibleId"
        refMovilConfirm.current.id = "confirmNotVisible"
      }
    }
  }
  const [image, setImage] = useState(
    "https://assets.planhopper.com/imgProject/00_DEFAULT.png",
  ) //useState(user['custom:avatar']);
  const [openImage, setOpenImage] = useState(false)
  const handleOpenImage = e => {
    e.preventDefault()
    setOpenImage(true)
  }
  return (
    <>
      <Modal
        open={modal_first}
        onClose={() => {
          null
        }}
      >
        <div
          data-testid="project-create-blank-modal"
          style={modalStyle}
          className={classes.paper}
        >
          <CloseIcon
            id="cerrar"
            data-testid="project-create-blank-modal-close"
            onClick={() => {
              setmodal_first(false)
            }}
          ></CloseIcon>
          <div id="UserImage">
            <img
              id="ProfileImage"
              onClick={handleOpenImage}
              className="rounded-circle header-profile-user"
              src={image}
              alt="Header Avatar"
            />
            <div id="foto">
              <EditOutlinedIcon
                onClick={handleOpenImage}
                id="fotoSize"
              ></EditOutlinedIcon>
            </div>
          </div>
          <form id="Form">
            <div id="inlineDiv">
              <div id="NombreProyecto">
                <p className="Titulos">{i18n.t("Nombre del Proyecto")}</p>
                <input
                  data-testid="project-create-blank-name-input"
                  onFocus={onFocus}
                  onBlur={onBlur}
                  onKeyDown={handleEnter}
                  ref={refNombre}
                  onClick={handleOnClick}
                  placeholder={i18n.t("Nombre del proyecto")}
                  name="name"
                  onChange={obtenerCampos}
                ></input>
                <CheckCircleOutlineSharpIcon
                  style={{ width: "16px", color: "#3BA452" }}
                  ref={refNombreConfirm}
                  id="confirmNotVisible"
                ></CheckCircleOutlineSharpIcon>
                <ErrorOutlineSharpIcon
                  style={{ width: "16px", color: "#BF2929" }}
                  ref={refNombreError}
                  id="errorNotVisible"
                ></ErrorOutlineSharpIcon>
              </div>
            </div>
            <div id="OtroConten">
              <div id="centerButton" style={{ paddingTop: "20px" }}>
                {loading ? (
                  <CircularProgress size={24} />
                ) : (
                  <button
                    type="submit"
                    data-testid="project-create-blank-submit-button"
                    onSubmit={onSubmit}
                    onClick={onSubmit}
                    className="AddContact"
                    data-amplify-analytics-on="click"
                    data-amplify-analytics-name="ProjectCreated"
                    data-amplify-analytics-attrs={campos}
                  >
                    {i18n.t("Crear Proyecto")}
                  </button>
                )}
              </div>
            </div>
          </form>
        </div>
      </Modal>

      <AddContact openAdd={openAdd} setOpenAdd={setOpenAdd} />
      <ModalImageProject
        openImage={openImage}
        setOpenImage={setOpenImage}
        campos={campos}
        image={image}
        setImage={setImage}
        first={true}
      ></ModalImageProject>
    </>
  )
}
ModalFirstProject.propTypes = {
  modal_first: PropTypes.bool.isRequired,
  setmodal_first: PropTypes.func.isRequired,
  imInDocuments: PropTypes.bool,
  imTemplate: PropTypes.bool,
}

export default ModalFirstProject
